import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X, Shield } from 'lucide-react';
import { getConsentState, setConsentState } from '../../lib/tracking';

export function ConsentBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const state = getConsentState();
        if (state === 'pending') {
            // Show banner after a short delay
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        setConsentState('granted');
        setVisible(false);
    };

    const handleDecline = () => {
        setConsentState('denied');
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                    className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
                >
                    <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
                        <div className="p-4 md:p-6">
                            <div className="flex items-start gap-4">
                                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                                    <Cookie className="w-6 h-6 text-primary-500" />
                                </div>
                                
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center justify-between gap-4 mb-2">
                                        <h3 className="font-display font-semibold text-lg text-secondary-900">
                                            Nous utilisons des cookies
                                        </h3>
                                        <button
                                            onClick={handleDecline}
                                            className="text-gray-400 hover:text-gray-600 transition-colors p-1"
                                            aria-label="Fermer"
                                        >
                                            <X className="w-5 h-5" />
                                        </button>
                                    </div>
                                    
                                    <p className="text-sm text-gray-600 mb-4">
                                        Nous utilisons des cookies et technologies similaires pour améliorer votre expérience, 
                                        personnaliser le contenu et les publicités, et analyser notre trafic. 
                                        En cliquant sur "Accepter", vous consentez à notre utilisation des cookies.
                                    </p>
                                    
                                    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                                        <button
                                            onClick={handleAccept}
                                            className="btn-primary px-6 py-2.5 text-sm font-medium"
                                        >
                                            Accepter tout
                                        </button>
                                        <button
                                            onClick={handleDecline}
                                            className="px-6 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-xl transition-colors"
                                        >
                                            Refuser
                                        </button>
                                        <div className="flex items-center gap-1.5 text-xs text-gray-500 sm:ml-auto">
                                            <Shield className="w-4 h-4" />
                                            <span>Vos données sont protégées</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
